import { axiosClient } from './request';

// Payment velocity is the fraud check that can hold a driver's payouts or take
// away their sign-in. These endpoints show why a driver is blocked and let an
// operator clear or apply a block.
//
// AU only: the other markets build the transaction facade with velocity
// disabled, so there is nothing for these routes to report there.
const paymentVelocityServices = {
  // userRestrictions returns the live and previously lifted blocks, plus the two
  // flags that say which source placed the current one.
  userRestrictions(userId) {
    return axiosClient.get(`/payment-velocity/users/${userId}/restrictions`);
  },
  incidents({ userId, ruleCode, from, to, pageSize = 20, pageIndex = 0 } = {}) {
    return axiosClient.get('/payment-velocity/incidents', {
      params: {
        user_id: userId,
        rule_code: ruleCode,
        from,
        to,
        limit: pageSize,
        page: pageIndex + 1
      }
    });
  },
  // releaseLogs is where an operator's note comes back. A restriction row has no
  // field for one, and a forced release that matched no rows leaves no
  // restriction behind at all, so this trail is the only record of either.
  releaseLogs(userId, { pageSize = 20, pageIndex = 0 } = {}) {
    return axiosClient.get(`/payment-velocity/users/${userId}/release-logs`, {
      params: {
        limit: pageSize,
        page: pageIndex + 1
      }
    });
  },
  // release is the only recovery action, so it clears blocks a fraud rule
  // applied and blocks an admin applied alike. An empty types array clears all
  // of them.
  //
  // Without force it refuses a driver this feature never blocked, because the
  // inactive-driver cron also leaves a driver locked and recover is one click.
  release(userId, { types = [], force = false, note = '' } = {}) {
    return axiosClient.post(`/payment-velocity/users/${userId}/release`, { types, force, note });
  },
  lock(userId, { types, note = '' }) {
    return axiosClient.post(`/payment-velocity/users/${userId}/lock`, { types, note });
  }
};

export default paymentVelocityServices;
